module.exports = __webpack_public_path__ + "8cad4a200f97f068f2ef20f34d27705f.png";